import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import moment from "moment";
import { getCharacterDetails } from "../../../../../store/actions";
import ImagesSpendToken from "../../../../../components/ImagesSpendToken";
import MessagesSpendToken from "../../../../../components/MessagesSpendToken";
const PublicView = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [userDetails, setUserDetails] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const { loading } = useSelector((state) => state.User);
  const getCharacterViews = () => {
    const callback = (err, res) => {
      if (err) {
        console.log(err);
      } else {
        // toast.success(res);
        setUserDetails(res);
      }
    };
    dispatch(getCharacterDetails({ data: id, callback }));
  };
  useEffect(() => {
    getCharacterViews();
  }, []);
  console.log(userDetails, "userDetails");
  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="addForm position-relative py-4">
        <Container>
          <Row className="">
            <Col md="4" className="my-2">
              <div className="flex-grow-1 d-flex flex-column">
                <div className="cardCstm p-3 border rounded-4 bg-light shadow-sm h-100">
                  <div className="top pt-2 pb-3 border-bottom border-secondary">
                    <h5 className="m-0 fw-bold themeClr">
                      {userDetails?.fullName}
                      <span
                        className="text-muted fw-sbold text-capitalize"
                        style={{ fontSize: 12 }}
                      >
                        ({userDetails?.type})
                      </span>
                    </h5>
                  </div>
                  <div
                    className="imgWrp justify-content-center mt-3 media-container"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <img
                      src={userDetails?.image || "placeholder.png"}
                      alt=""
                      style={{ height: "300px" }} // Add this back
                      className="w-100 h-100 object-fit-cover rounded"
                    />
                    {userDetails?.profileVideoUrl && (
                      <video
                        src={userDetails?.profileVideoUrl}
                        muted
                        loop
                        style={{ height: "300px" }} // Add this to video as well
                        className={`w-100 h-100 object-fit-cover rounded media-overlay ${
                          isHovered ? "show" : ""
                        }`}
                        onTransitionEnd={(e) => {
                          if (isHovered) {
                            e.target.play();
                          } else {
                            e.target.pause();
                            e.target.currentTime = 0;
                          }
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col md="8" className="my-2">
              <div className="flex-grow-1 d-flex flex-column">
                <div className="cardCstm border rounded-4 bg-light shadow-sm px-2 py-2">
                  <div className="content">
                    {/* <div className="d-flex justify-content-between">
                      <h6 className="m-0 fw-bold themeClr">Age:</h6>
                      <span>{userDetails?.age}</span>
                    </div> */}
                    <ul className="list-unstyled" style={{ fontSize: 12 }}>
                      <li className="d-flex justify-content-between">
                        <p className="themeClr m-0 fw-bold">Date Of Birth:</p>
                        <p className="py-1 m-0">{userDetails?.dob}</p>
                      </li>
                      <li className="d-flex justify-content-between">
                        <p className="themeClr m-0 fw-bold">Gender :</p>
                        <p className="py-1 m-0">{userDetails?.gender}</p>
                      </li>
                      <li className="d-flex justify-content-between">
                        <p className="themeClr m-0 fw-bold">Profession:</p>
                        <p className="py-1 m-0">{userDetails?.profession}</p>
                      </li>
                      <li className="d-flex justify-content-between">
                        <p className="themeClr m-0 fw-bold">Education :</p>
                        <p className="py-1 m-0">{userDetails?.education}</p>
                      </li>
                      <li>
                        <p className="themeClr m-0 fw-bold">Life Story :</p>
                        <p className="py-1 m-0">{userDetails?.lifeStory}</p>
                      </li>
                    </ul>
                  </div>
                  <div className="border-bottom">
                    <h5 className="m-0 fw-bold" style={{ color: "#2E3A59" }}>
                      Other Details
                    </h5>
                  </div>
                  <div className="content mt-3">
                    <div className="d-flex justify-content-between border-bottom py-1">
                      <p className="fw-bold m-0 themeClr">Hobby:</p>
                      <p className="m-0">
                        {userDetails?.hobby
                          ?.map((item) => item.trim())
                          .join(", ")}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between border-bottom py-1">
                      <p className="fw-bold m-0 themeClr">Personality:</p>
                      <p className="m-0">
                        {userDetails?.personality
                          ?.map((item) => item.trim())
                          .join(", ")}
                      </p>
                    </div>
                    {/* <div className="d-flex justify-content-between border-bottom py-1">
                      <p className="fw-bold m-0 themeClr">Tags:</p>
                      <p className="m-0">
                        {userDetails?.tag
                          ?.map((item) => item.trim())
                          .join(", ")}
                      </p>
                    </div> */}
                    <div className="d-flex justify-content-between border-bottom py-1">
                      <p className="fw-bold m-0 themeClr">Character Type:</p>
                      <p className="m-0">{userDetails?.type}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {/* <Row className="">
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="Dashboard"
              >
                <Nav variant="pills" className="btnPillsTab row mx-0">
                  <Nav.Item className="col-lg-3 col-sm-6 my-2 px-0">
                    <Nav.Link
                      className="d-flex align-items-center justify-content-center border rounded-0"
                      eventKey="Dashboard"
                    >
                      Images Spend Token
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="col-lg-3 col-sm-6 my-2 px-0">
                    <Nav.Link
                      className="d-flex align-items-center justify-content-center border rounded-0"
                      eventKey="Programs"
                    >
                      Messages Spend Token 
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content className="pt-4">
                  <Tab.Pane eventKey="Dashboard">
                    <ImagesSpendToken id={id}  type="words"/>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Programs">
                    <MessagesSpendToken id={id} type="image"/>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row> */}
        </Container>
      </section>
    </>
  );
};

export default PublicView;
